export const isMobile = window.innerWidth < 768;

export const isOnScreen = function(el) {
	const $window = $(window);
	const viewport = {
	  top: $window.scrollTop(),
	  left: $window.scrollLeft()
	};
	viewport.right = viewport.left + $window.width();
	viewport.bottom = viewport.top + $window.height();
	const bounds = $(el).offset();
	bounds.right = bounds.left + $(el).outerWidth();
	bounds.bottom = bounds.top + $(el).outerHeight();
	if (bounds.left === bounds.right === 0) return false;
	return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

export class GAServices {

	static trackingGA(object) {
		window.dataLayer = window.dataLayer || [];
		if (window.dataLayer !== undefined) {
			window.dataLayer.push({ecommerce: null});
		  	window.dataLayer.push(object);
		}
	}

	static getAttributesWithPrefix(element, prefix) {
		let result = {};
		$.each(element[0].attributes, function(index, attr) {
			if (attr.name.startsWith(prefix) && attr.value !== '') {
				const strippedName = attr.name.substring(prefix.length).replace(/-/g, '_');
				result[strippedName] = attr.value;
			}
		});
		return result;
	}

	static viewItemTracking(el, isRecommend = false) {
		const $el = $(el);
		const trackingItem = '[ga-tracking-item]:not(.tracked)';
		const $productList = isRecommend ? $el.find('.slide-active').find(trackingItem) : $el.find(trackingItem);
		const dataTracking = {
			event: 'view_item_list',
			ecommerce: {
				currency: $('body').data('currency'),
				items: [],
			}
		};
		let items = [];
		if ($productList.length) {
			$productList.each((index, product) => {
				if (isOnScreen(product)) {
					const $product = $(product);
					const data = GAServices.getAttributesWithPrefix($product, 'ga-');
					items.push(data);
					$product.addClass('tracked');
				}
			});
			if (items.length) {
				dataTracking.ecommerce.items = items;
				items = [];
				GAServices.trackingGA(dataTracking);
			}
		}
	};

	static selectItem(el, self = true) {
		$(el).on('click', (e) => {
			const product = self ? el : el.closest('[ga-tracking-item]');
			const currency = $('body').data('currency');
			const dataTracking = {
				event: 'select_item',
				ecommerce: {
					currency: currency,
					items: [],
				}
			};
			if ($(el).attr('data-trigger-quick-order')) {
				dataTracking['view_type'] = 'quickorder';
			}
			const data = GAServices.getAttributesWithPrefix($(product), 'ga-');
			if (!self) {
				const idColor = $(el).attr('data-ga-item-id');
				const variant = $(el).attr('data-ga-item-variant');
				if (idColor) data.item_id = idColor;
				if (variant) data.item_variant = variant;
			}
			dataTracking.ecommerce.items.push(data);
			GAServices.trackingGA(dataTracking);
			GAServices.saveListItemsName(dataTracking.ecommerce.items[0]);
		});
	}

	static saveListItemsName(data) {
		const saveData = {
			item_id: data.item_id,
			index: data.index,
			item_list_name: data.item_list_name,
			list_category: data.list_category,
			list_category2: data.list_category2,
			list_category3: data.list_category3,
		};
		const listItemTracking = localStorage.getItem('selectTrackingData');
		let listItems = [];
		if (listItemTracking) {
			listItems = JSON.parse(listItemTracking);
		}
		if (listItems.length) {
			const index = listItems.map((item) => item.item_id).indexOf(data.item_id);
			if (index > -1) {
				listItems.splice(index, 1);
			}
		}
		listItems.push(saveData);
		localStorage.setItem('selectTrackingData', JSON.stringify(listItems));
	}

	static getItemListName(id) {
		let item = {
			item_id: id,
		};
		const listItemTracking = localStorage.getItem('selectTrackingData');
		let listItems = [];
		if (listItemTracking) {
			listItems = JSON.parse(listItemTracking);
			const temp = listItems.filter((item) => item.item_id === id)[0];
			if (temp) item = temp;
		}
		return item;
	}

	static filterEmptyData(item) {
		return Object.keys(item).reduce((_result, _current) => {
			const value = item[_current];
			if (value !== '') {
				_result[_current] = value;
			}
			return _result;
		}, {});
	}

	static addGAForSearchAutoComplete(string, results) {
		const parser = new DOMParser();
		const doc = parser.parseFromString(string, "text/html");
		const items = doc.body.firstChild.querySelectorAll('.search-dropdown__result-item');
		items.forEach((item, index) => {
			const datalayer = results[index].Datalayer;
			if(datalayer) {
				item.setAttribute('ga-tracking-item', '');
				item.setAttribute('ga-tracking-link', '');
				Object.keys(datalayer).forEach(key => {
					item.setAttribute(`ga-${key.replace(/_/g, '-')}`, datalayer[key]);
				});
				item.setAttribute('ga-item-list-name', 'Search Suggestion');
				item.setAttribute('ga-index', index + 1);
				item.removeAttribute('ga-quantity');
				item.removeAttribute('ga-list-category');
				item.removeAttribute('ga-list-category2');
				item.removeAttribute('ga-list-category3');
			}
		});
		return doc.body.innerHTML;
	}

	static getDataLayer($product, attr) {
		const data = [];
		$product.forEach((item, index) => {
			const $dataItem = item.getAttribute(attr);
			if (!$dataItem) return;
			const _datalayer = JSON.parse($dataItem);
			const dataItemList = GAServices.getItemListName(_datalayer.item_id);
			if (dataItemList.item_list_name === 'Search Suggestion') {
				dataItemList.list_category = undefined;
				dataItemList.list_category2 = undefined;
				dataItemList.list_category3 = undefined;
			}
			const product = Object.assign({}, _datalayer, dataItemList);
			if (!product.status) {
				delete product.status;
			}
			data.push(GAServices.filterEmptyData(product));
		});
		return data;
	}

	static sendPaymentInfo() {
		const value = (document.querySelector('[data-sub-total]') && document.querySelector('[data-sub-total]').dataset.subTotal) ? document.querySelector('[data-sub-total]').dataset.subTotal.replace('$', '') : undefined;
		let payment = '';
		const $paymentList = document.querySelectorAll('[name="paymentMethod"]');
		if ($paymentList.length > 1) {
			payment = Array.from($paymentList).filter((item) => item.checked)[0].dataset.gaName;
		} else if ($paymentList.length === 1) {
			payment = $paymentList[0].dataset.gaName;
		} else {
			return;
		}
		const count = document.querySelector('.order-summary').dataset.trackingCount;
		let data = JSON.parse(localStorage.getItem('cartTrackingData')) || [];
		// Check promo code at step payment
		const $orderedItems = document.querySelectorAll('.cart-item');
		if ($orderedItems.length) {
			data = GAServices.getDataLayer($orderedItems, 'data-item-datalayer');
			localStorage.setItem('cartTrackingData', JSON.stringify(data));
		}
		const dataTracking = {
			event: 'add_payment_info',
			ecommerce: {
				currency: $('body').data('currency'),
				value: value,
				item_count: count,
				payment_type: payment,
				items: data,
			}
		};
		GAServices.trackingGA(dataTracking);
		localStorage.removeItem('orderIdTracking');
	}
}



// WEBPACK FOOTER //
// ./client/src/core/services/ga-services.js